<template>
  <!-- 用户管理-赠送活动商城币 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="赠送活动商城币"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        v-if="dataForm"
        :model="dataForm"
        ref="dataForm"
        label-width="80px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="id" label="用户id">
          <el-input v-model="dataForm.id" :disabled="true"> </el-input>
        </el-form-item>
        <el-form-item prop="name" label="用户姓名">
          <el-input v-model="dataForm.name" :disabled="true"> </el-input>
        </el-form-item>
        <el-form-item prop="receive_amount" label="金额">
          <el-input placeholder="请输入金额" v-model="dataForm.receive_amount">
          </el-input>
        </el-form-item>
        <el-form-item prop="failure_time" label="过期时间">
          <el-date-picker
            v-model="dataForm.failure_time"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      lock: false,//加锁
      dataForm: {
        id: '',
        name: '',
        receive_amount: '',
        failure_time: '',

      },
      replyRules: {//回复弹窗规则验证
        id: [
          {
            required: true,
            message: 'id不能为空',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: 'blur'
          }
        ],
        receive_amount: [
          {
            required: true,
            message: '金额不能为空',
            trigger: 'blur'
          }
        ],
        failure_time: [
          {
            required: true,
            message: '过期时间不能为空',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.dataForm.id = this.value.id
        this.dataForm.name = this.value.name
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          let params = {
            user_id: this.dataForm.id,
            receive_amount: this.dataForm.receive_amount,
            failure_time: this.dataForm.failure_time,
          }
          postApiData('giving_shop_coins', params).then(res => {
            if (res.code) {
              this.$message.success(res.message)
              this.$emit('refresh')
              this.closeDialog()
            } else {
              this.$message.error(res.message)
            }
          }).finally(() => {
            this.buttonLoading = false
          })
        }
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>